import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function PromiseBand() {
  return <section aria-labelledby="promesa-titulo" className="relative w-full overflow-hidden bg-ink text-cream" data-id="element-154" data-mp="1fe48wr9rl9h9">
      <div className="blueprint-grid-dark absolute inset-0" aria-hidden="true" data-id="element-155" data-mp="1u5wa7zcq4mzz" />
      <div className="relative mx-auto max-w-4xl px-5 py-16 text-center sm:px-8 sm:py-24" data-id="element-156" data-mp="1p58kdh08ec7c">
        <Reveal data-id="element-157" data-mp="11fxi1v38g9r3">
          <div className="flex justify-center" data-id="element-158" data-mp="11fe9h4zh2xpq">
            <SectionLabel tone="dark" data-id="element-159" data-mp="wgksv3ow2qlc">La promesa</SectionLabel>
          </div>
          <h2 id="promesa-titulo" className="mx-auto mt-6 max-w-3xl font-display text-3xl font-bold leading-[1.1] sm:text-[2.9rem]" data-id="element-160" data-mp="1afuckdcb02u2">
            Al terminar este libro vas a poder hacer tus primeros arreglos en
            casa con <span className="text-clay" data-id="element-161" data-mp="2ltejxpiaqeer">seguridad y confianza real</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-cream/75" data-id="element-162" data-mp="2hsmaow9fc9ih">
            Sin necesitar experiencia previa. Sin herramientas caras. Sin
            depender de nadie. Solo instrucciones simples, claras y directas que
            podés aplicar desde el primer día.
          </p>
        </Reveal>
      </div>
    </section>;
}